import { Tag } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";
import { useViewConditionTag } from "./use-view-condition-tag";
import { DetailPriceText } from "~/components/blocks/product/common/blocks/detail-price-text";
import type { G_GetVideoQuery } from "~/lib/graphql";
import { G_ServicePlan, G_VideoSeasonType } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

type ViewConditionTagProps = {
  videoData: G_GetVideoQuery["video"];
};

/**
 * 視聴条件を表示するコンポーネント
 */
export const ViewConditionTag = (props: ViewConditionTagProps) => {
  const { videoData } = props;
  const { seasonType } = videoData;

  const { servicePlan } = useAuth();

  const {
    freeProduct,
    ppvProducts,
    svodProduct,
    ppvExpiration,
    purchaseSubText,
    isAnotherPurchased,
    anotherPurchaseBtnClicked,
  } = useViewConditionTag({ videoData });

  if (seasonType === G_VideoSeasonType.Stage) return null;

  if (ppvExpiration !== undefined && ppvExpiration !== null) {
    return (
      <Styled.DivPurchaseFlex>
        <Tag
          tagText="購入済み"
          subText={purchaseSubText}
          color="BLUE900"
          subTextColor="GRAY500"
          borderColor="BLUE900"
        />

        {isAnotherPurchased && (
          <Styled.BtnPurchase type="button" onClick={anotherPurchaseBtnClicked}>
            その他の購入方法
          </Styled.BtnPurchase>
        )}
      </Styled.DivPurchaseFlex>
    );
  }

  if (svodProduct !== undefined && svodProduct !== null && 0 < ppvProducts.length) {
    return (
      <Styled.DivTagFlexContainer>
        <Tag tagText="プレミアム" color="YELLOW50" borderColor="YELLOW50" />
        <Styled.SpanText>または</Styled.SpanText>
        <DetailPriceText ppvProducts={ppvProducts} />

        {isAnotherPurchased && (
          <Styled.BtnPurchase type="button" onClick={anotherPurchaseBtnClicked}>
            その他の購入方法
          </Styled.BtnPurchase>
        )}
      </Styled.DivTagFlexContainer>
    );
  }

  if (freeProduct !== undefined && freeProduct !== null) {
    if (servicePlan === G_ServicePlan.Premium) return null;
    return <Tag tagText="無料" borderColor="GRAY900" color="GRAY900" />;
  }

  if (svodProduct !== undefined && svodProduct !== null) {
    return <Tag tagText="プレミアム" color="YELLOW50" borderColor="YELLOW50" />;
  }

  if (0 < ppvProducts.length) {
    return <DetailPriceText ppvProducts={ppvProducts} />;
  }

  return null;
};
